import { z } from "zod";

/**
 * The contract between the AI Engine and everything downstream.
 * Mistral's response is validated against this schema before the
 * Harness ever sees it — an unparsed/invalid response triggers a
 * retry or fallback-model call, never a raw pass-through to the UI.
 */
export const LessonActionSchema = z.discriminatedUnion("type", [
  z.object({ type: z.literal("speak"), text: z.string().min(1), pace: z.enum(["slow", "normal", "fast"]).optional() }),
  z.object({ type: z.literal("write"), target: z.string(), content: z.string() }),
  z.object({ type: z.literal("draw"), target: z.string(), shape: z.string(), refs: z.array(z.string()).optional() }),
  z.object({ type: z.literal("highlight"), target: z.string() }),
  z.object({ type: z.literal("pause"), ms: z.number().int().min(0).max(5000) }),
  z.object({ type: z.literal("question"), prompt: z.string().min(1), checkpoint: z.boolean().optional() }),
  z.object({ type: z.literal("wait_for_answer") }),
  z.object({ type: z.literal("summary"), text: z.string() }),
  z.object({ type: z.literal("homework"), items: z.array(z.string()) }),
]);

export const LessonActionListSchema = z.object({
  actions: z.array(LessonActionSchema).min(1),
});

export type ValidatedLessonAction = z.infer<typeof LessonActionSchema>;

export const EvaluationSchema = z.object({
  correct: z.boolean(),
  feedback: z.string(),
  weakConcept: z.string().optional(),
});
